import { render, staticRenderFns } from "./UpdateJobsTab.vue?vue&type=template&id=119fdc8b&"
import script from "./UpdateJobsTab.vue?vue&type=script&lang=ts&"
export * from "./UpdateJobsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports